import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { StyledTitle } from 'components/StyledTitle';
import { Spinner, GenericResult } from 'components';

import { BankTransferInformation } from './BankTransferInformation';
import { SecondaryInfoText } from '../components/SecondaryInfoText';
import { useChequeInfo } from '../hooks';

const { Text } = Typography;

export const ChequePanelContent = (): JSX.Element => {
  const { t } = useTranslation();

  const { data, error } = useChequeInfo();

  if (!data && !error) return <Spinner />;

  if (error || !data) return <GenericResult hideDefaultExtra />;

  return (
    <>
      <p>{t('cms.shortfall.settle.cheque.instruction')}</p>

      <div>
        <Text type="secondary">{t('shortfallPayment.cheque.directMailTo')} </Text>
        <StyledTitle level={5}>
          {data.directMailTo.split('\n').map((str) => (
            <React.Fragment key={str}>
              {str}
              <br />
            </React.Fragment>
          ))}
        </StyledTitle>
        <br />
      </div>

      <p>{t('shortfallPayment.cheque.depositToBank')}</p>

      <BankTransferInformation {...data} />

      <SecondaryInfoText content={t('cms.shortfall.settle.cheque.info')} />
    </>
  );
};
